<template>
  <div
    class="mt-8">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <v-select
                filled
                rounded
                dense

                color="#718EBF"
                placeholder="Contoh. 2023"

                hide-details

                :items="years"
                :item-color="set_color"

                v-model="filter.year"
                style="border-radius: 10px;">
              </v-select>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.target"
          @keydown.esc="dialog.target = false"
          :fullscreen="dialog.fullscreen"
          width="1000"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold" v-if="Object.keys(selected.target).length > 0">
              
              Target

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.target = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.target = false;"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>

            <v-card-text class="mt-3" v-if="Object.keys(selected.target).length > 0">
              <div class="d-flex align-center mb-5">
                <div class="label-input fs-17 pt-2">
                  Data Target Sales {{ selected.target.name }}
                </div>
                <div class="ml-auto">
                  <v-btn
                    color="#1814F3"
                    width="195"
                    small
                    height="35"
                    elevation="0"
                    style="border-radius: 9px;"
                    @click="reset(); dialog.add_target = true;"
                    class="fs-14 white--text text-capitalize">
                    <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                    Tambah Customer
                  </v-btn>
                </div>
              </div>
              <v-data-table
                :headers="header_target"
                :items="target"
                ref="table-grid"
                class="table-grid"
                height="calc( 100vh - 350px )"
                :loading="process.target"
                loading-text="Sedang memuat data . . ."
                loader-height="5"
                no-results-text="Belum ada data"
                elevation="0"
                hide-default-footer
                :single-select="false"
                item-key="id"
                :items-per-page="1000000000"

                style="border: 1px solid #E7E7E7;"
              >
              <template
                  v-for="header in header_target.filter((header) => header.hasOwnProperty('format'))"
                  v-slot:[`item.${header.value}`]="{ value, index }">
                <div
                  v-bind:key="header.value">
                  <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'&& header.format !== 'nominal'">
                    {{ rowFormat(header.format, value) }} 
                  </div>

                  <div v-if="header.format === 'link'"
                    class="cursor-pointer">
                    
                  </div>
    
                  <div v-if="header.format === 'regex'">
                    <span
                      class="two-line">
                      {{ rowFormat(header.format, value) }}
                    </span>
                  </div>
    
                  <div v-if="header.format === 'image'"
                    class="ma-4">
                    <v-avatar
                      size="60"
                      tile
                      style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                      <v-img 
                        contain
                        width="100%"
                        height="100%"
                        alt="Mitra Warung" 
                        :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              color="#718EBF">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                  </div>

                  <div v-if="header.format === 'image_potrait'"
                    class="ma-4">
                    <v-img 
                      contain
                      width="100"
                      height="125"
                      alt="Mitra Warung" 
                      :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                      class="ma-auto"
                      style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            color="#718EBF">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <div v-if="header.format === 'image_landscape'"
                    class="ma-4">
                    <v-img 
                      contain
                      width="200"
                      height="125"
                      alt="Mitra Warung" 
                      :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                      class="ma-auto"
                      style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            color="#718EBF">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <div v-if="header.format === 'action'">
                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="reset(index); dialog.add_target = true;"
                          
                          v-bind="attrs"
                          v-on="on"

                          min-width="28"
                          small
                          rounded
                          color="blue"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>

                      <span>Ubah</span>
                    </v-tooltip>
                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        
                          @click="selected.delete = [value]; dialog.delete_target = true;"

                          v-bind="attrs"
                          v-on="on"

                          min-width="28"
                          small
                          rounded
                          color="red"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      
                      <span>Hapus</span>
                    </v-tooltip>
                    <!-- <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          elevation="0"
                          color="#1814F3"
                          height="35"
                          width="100"
                          class="text-capitalize ma-2"
                          :to="`/customer/edit/${value}`"
                        >
                          Ubah
                        </v-btn>
                      </template>

                      <span>Ubah</span>
                    </v-tooltip>
                    <v-tooltip 
                    top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        outlined
                        rounded
                        v-bind="attrs"
                        v-on="on"
                        elevation="0"
                        color="#16DBCC"
                        height="35"
                        width="100"
                        class="text-capitalize ma-2"
                        :to="`/customer/${value}`"
                      >
                        Detail
                      </v-btn>
                    </template>

                    <span>Detail</span>
                  </v-tooltip>
                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          elevation="0"
                          color="red"
                          height="35"
                          width="100"
                          class="text-capitalize ma-2"
                          @click="toDelete(value)"
                        >
                          Hapus
                        </v-btn>
                      </template>

                      <span>Hapus</span>
                    </v-tooltip> -->
                  </div>

                  <div v-if="header.format === 'status'"
                    class="d-flex justify-start text-capitalize font-weight-medium" :class="value == 'Publish' ? 'blue--text text--darken-2' : 'red--text'">
                    {{ value }}
                  </div>

                  <div v-if="header.format === 'nominal'">
                    {{ value | price }}
                  </div>
                </div>
              </template>
              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>
            </v-data-table>
            </v-card-text>
            
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.add_target"
          @keydown.esc="dialog.add_target = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold" v-if="Object.keys(selected.target).length > 0">
              
              {{ selected.target.name }}

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.add_target = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.add_target = false;"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>

            <v-card-text class="mt-3">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Varian" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->
                      Varian
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo

                      color="#718EBF"
                      placeholder="Varian"

                      
                      :items="varian"
                      item-value="id"
                      item-text="name"
                      :item-color="set_color"

                      v-model="form.varian_id"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kuantitas" 
                    rules="required|min:0" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      Kuantitas
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo

                      color="#718EBF"
                      placeholder="Kuantitas"
                      type="number"

                      

                      v-model="form.qty"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>


                  </ValidationProvider>

                  <ValidationProvider
                    name="Nominal" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->
                      Nominal
                    </div>
                    <v-currency-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo

                      color="#718EBF"
                      placeholder="Nominal"
                      

                      v-model="form.nominal"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-currency-field>
                  </ValidationProvider>

                  <div class="fs-15 label-input">
                  <!-- <span class="red--text">*</span> -->
                  
                    Tanggal
                  </div>

                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <ValidationProvider 
                        name="Tanggal" 
                        rules="required" 
                        v-slot="{ errors }">
                        <v-text-field
                          v-model="form.date"
                          
                          v-on:keyup.enter="save()"
                          
                          filled
                          solo
                          rounded
                          dense
                          
                          :color="set_color"
                          placeholder="Tanggal"

                          :disabled="Object.keys(form).length < 1"

                        

                          :error-messages="errors"
                          required
                          style="border-radius: 10px;"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          >
                        </v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="form.date"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                :loading="process.delete"
                :disabled="process.delete"
                @click="save()"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete_target"
          @keydown.esc="dialog.delete_target = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Hapus Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete_target = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.delete_target = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Target</b> yang Anda pilih?

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="deletes_target()"
                :loading="process.delete"
                :disabled="process.delete"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Hapus
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Hapus Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Hapus
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.status"
          @keydown.esc="dialog.status = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Ubah Status Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3" v-if="Object.keys(selected.status).length > 0">
              Apakah Anda yakin mengubah status Sales <b class="font-weight-bold black--text">{{ selected.status.name }}</b> ?

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="statuses()"
                :loading="process.delete"
                :disabled="process.delete"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Ubah
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.reset"
          @keydown.esc="dialog.reset = false"
          :fullscreen="dialog.fullscreen"
          width="520"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Reset Password

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.reset = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3" v-if="Object.keys(selected.reset).length > 0">
              <div>
                Apakah Anda yakin mereset password <b class="font-weight-bold black--text">{{ selected.reset.name }}</b> ?
              </div>

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="reset_password()"
                :loading="process.delete"
                :disabled="process.delete"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Reset
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>

          <v-card 
            flat
            class="ma-4 mt-0 box-shadow pb-5"
            style="border-radius: 10px;">

            <v-row
              class="pa-4 py-0">
              <v-col
                cols="12"
                md="7">
                <span
                  class="fs-16 black--text ml-2"
                  style="font-weight: 600;">
                  Sales
                </span>
                <!-- <div
                  class="body-2">
                  Perbandingan SP2D 

                  <span v-if="filter.year !== '' && filter.year !== null">
                    tahun <strong class="black--text">{{ filter.year }}</strong>
                  </span>

                  <span v-if="filter.month !== '' && filter.month !== null">
                    di bulan <strong class="black--text">{{ filter.month_text }}</strong>
                  </span>
                </div> -->
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="d-flex align-center">
                <v-btn
                  color="#4B4B4B"
                  elevation="0"
                  :disabled="process.load"
                  to="/sales/staff/add"
                  class="body-2 white--text text-capitalize d-flex align-center ml-0"
                  style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2">
                    Tambah
                  </span>
                </v-btn>
                <v-text-field
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line

                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable

                  v-model="search"
                  class="ml-3 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                </v-text-field>

                <!-- FREEZE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div> -->

                <!-- HIDE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div> -->
              </v-col>
            </v-row>

            <v-card 
              flat
              class="mt-0 mx-5"
              style="border-radius: 25px; border: 1px solid #E7E7E7;">
              <!-- :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '148px'})`" -->
              <div class="view">
                <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                  <table style="border-radius: 10px; width: 100%;" class="table">
                    <tr>
                      <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                      <th @click="sortBy !== 'name' ? toSort('name') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Nama
                        <span v-if="sortBy === 'name'">
                          <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th>
                      <th @click="sortBy !== 'sales_region_name' ? toSort('sales_region_name') : toDesc();" style="width: 1px; white-space: nowrap; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Kode Sales (Area Sales)
                        <span v-if="sortBy === 'sales_region_name'">
                          <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th>
                      <th @click="sortBy !== 'mobilephone' ? toSort('mobilephone') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        No. handphone
                        <span v-if="sortBy === 'mobilephone'">
                          <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th>
                      <th @click="sortBy !== 'email' ? toSort('email') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Email
                        <span v-if="sortBy === 'email'">
                          <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th>
                      <th style="z-index: 1; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Status
                        <span v-if="sortBy === 'sales_region_name'">
                          <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th>
                      <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                      <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                      <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                    </tr>
                    <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                      <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 220px; min-width: 220px; max-width: 220px; padding: 8px 12px; text-align: center;">
                        <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :to="`/sales/staff/detail/${item.id}`"
                          
                          v-bind="attrs"
                          v-on="on"
                          
                          min-width="28"
                          small
                          rounded
                          color="green"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-information-outline</v-icon>
                        </v-btn>
                      </template>

                      <span>Detail</span>
                    </v-tooltip>

                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :to="`/sales/staff/edit/${item.id}`"
                          
                          v-bind="attrs"
                          v-on="on"

                          min-width="28"
                          small
                          rounded
                          color="blue"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>

                      <span>Ubah</span>
                    </v-tooltip>

                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <!-- @click="selected.target = item; dialog.target = true; fetchTarget(item.id);" -->
                        <v-btn
                          :to="`/sales/staff/detail/${item.id}?menu=target`"
                          
                          v-bind="attrs"
                          v-on="on"
                          
                          min-width="28"
                          small
                          rounded
                          color="yellow"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-target-account</v-icon>
                        </v-btn>
                      </template>

                      <span>Target</span>
                    </v-tooltip>

                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="selected.status = item; dialog.status = true;"
                          
                          v-bind="attrs"
                          v-on="on"

                          min-width="28"
                          small
                          rounded
                          color="indigo"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small v-if="item.is_active === 'Aktif'">mdi-account-cancel</v-icon>
                          <v-icon small v-else>mdi-account-check</v-icon>
                        </v-btn>
                      </template>

                      <span>Ubah Status</span>
                    </v-tooltip>

                    <!-- <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="toDelete(value)"

                          v-bind="attrs"
                          v-on="on"

                          min-width="28"
                          small
                          rounded
                          color="red"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      
                      <span>Hapus</span>
                    </v-tooltip> -->

                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="selected.reset = item; dialog.reset = true;"

                          v-bind="attrs"
                          v-on="on"
                          
                          min-width="28"
                          small
                          rounded
                          color="orange"
                          elevation="0"
                          class="white--text text-capitalize px-0 mx-1"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon small>mdi-lock-reset</v-icon>
                        </v-btn>
                      </template>

                      <span>Reset Password</span>
                    </v-tooltip>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.name }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.sales_region_name }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 200px; min-width: 200px; text-align: left;" class="text-lowercase">{{ item.mobilephone }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 200px; min-width: 200px; text-align: left;" class="text-lowercase">{{ item.email }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;" class="text-capitalize">
                        <v-chip
                          color="green"
                          v-if="item.is_active === 'Aktif'"
                          class="white--text">
                          Aktif
                        </v-chip>
                        <v-chip
                          color="red"
                          v-else
                          class="white--text">
                          Tidak Aktif
                        </v-chip>
                      </td>
                      <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                      <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                        {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                        {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                      </td> -->
                    </tr>
                  </table>
                </div>

                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <v-card-text
                  v-if="list.length === 0"
                  class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="90"
                      :height="90"
                      :src="require('@/assets/image/empty.png')">
                      <!-- <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template> -->
                    </v-img>
                    <div class="mt-3 fs-16">
                      Belum Ada Data
                    </div>
                  </div>
                </v-card-text>

                <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/>

              </div>


              <!-- <pagination v-if="pagination.total_data > 0"
                @changePage="fetch($event)" 
                @reloadPage="fetch($event)" 
                :model="pagination"/> -->
            </v-card>
          </v-card>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false,
          status: false,
          reset: false,
          target: false,
          add_target: false,

          delete_target: false,
        },

        header_target:[],
        target: [],
        sortBy: 'id',
        sortDesc: '-',

        
        search: '',

        filter: {
          year: new Date().getFullYear()
        },

        selected: {
          freeze: [],
          delete: [],
          row: [],
          status: {},
          reset: {},
          target: {}
        },

        sales: [],

        form: {
          id: '',
          sales_id: '',
          varian_id: '',
          qty: '',
          nominal: '',
          date: ''
        },

        varian: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {
          page: 1,
          row: 50
        },

        lastIndex: 0,
        limit: 50,

        process: {
          load: false,

          delete: false,

          target: false,
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetchSales()
      this.fetchVarian()
      this.fetch()
    },
    methods: {
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        } else if (format === 'nominal') {
          data = value
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },

      async fetchSales () {
        this.process.load = true

        let params = {
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/sales_region/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.sales = res.results.data
            
          }
          this.process.load = false
        })
      },

      async fetchVarian () {
        this.process.load = true

        let params = {
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/varian/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.varian = res.results.data
            
          }
          this.process.load = false
        })
      },

      async fetchTarget (id) {
        this.process.target = true

        let params = {
          limit: 1000000,
          sales_id: id
        }

        await get(`admin/target_sales/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.header_target = [
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'Varian',
                width: '200px',
                value: 'varian_name',
                freeze: true,
                hide: false
              },
              {
                text: 'Qty',
                width: '200px',
                value: 'qty',
                freeze: false,
                hide: false
              },
              {
                text: 'Nominal',
                width: '200px',
                value: 'nominal',
                freeze: false,
                hide: false,
                format: 'nominal'
              },
              {
                text: 'Tanggal',
                width: '200px',
                value: 'date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: '',
                width: '150px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'end',
                format: 'action'
              },
            ]
            this.target = res.results.data
            
          }
          this.process.target = false
        })
      },

      async fetch (pagination = { row: 50, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          'category_user_id[eq]': '8',
          search: this.search,
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : '',
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: '',
                width: '220px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'start',
                format: 'action'
              },
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama',
                width: '200px',
                value: 'name',
                freeze: true,
                hide: false
              },
              // {
              //   text: 'Kategori Sales',
              //   width: '200px',
              //   value: 'category_user_title',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Cabang',
                width: '150px',
                value: 'branch_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Mobilephone',
                width: '180px',
                value: 'mobilephone',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '200px',
                value: 'email',
                freeze: false,
                hide: false
              },
              // {
              //   text: 'Alamat',
              //   width: '300px',
              //   value: 'address',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Status',
                width: '200px',
                value: 'is_active',
                freeze: false,
                hide: false,
                format: 'status'
              },
              // {
              //   text: 'Bergabung Pada',
              //   width: '200px',
              //   value: 'join_date',
              //   freeze: false,
              //   hide: false,
              //   format: 'date'
              // },
            
            ]
    
            this.list = res.results.data
            this.pagination = res.results.pagination

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.target[index].id : '',
          varian_id: index !== undefined ? this.target[index].varian_id : '',
          qty: index !== undefined ? this.target[index].qty : '',
          nominal: index !== undefined ? this.target[index].nominal : '',
          date: index !== undefined ? this.target[index].date : '',
          sales_id: this.selected.target.id
          // is_active: index !== undefined ? this.list[index].is_active === 'Aktif'? 1 : 0 : 1
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/target_sales/add' : 'admin/target_sales/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false
              this.dialog.add_target = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetchTarget()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async statuses () {
        this.message.error = ''

        this.process.delete = true

        let url = this.selected.status.is_active === 'Aktif' ? 'admin/user/deactivate' : 'admin/user/activate'

        await post(url, {
          data: {
            id: this.selected.status.id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.status = false

            this.selected.status = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },

      async reset_password () {
        this.message.error = ''

        this.process.delete = true


        await post(`admin/user/reset_password`, {
          data: {
            id: this.selected.reset.id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.reset = false

            this.selected.reset = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/user/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false
            

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },
      async deletes_target () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/target_sales/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete_target = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchTarget()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper { 
    overflow-y: auto; 
    height: calc(100vh - 310px); 
  } 

  .wrapper-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 

  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
</style>